import React, { Component } from 'react';
import { Container, Row, Col, Image, Dropdown, DropdownButton, Form, FormControl, Button, Pagination, Modal } from 'react-bootstrap';
import { Spinner } from 'react-activity';
import { QRCode } from 'react-qrcode-logo';
import { store } from 'react-notifications-component';

import NavbarComponent from '../../Navbar/index';
import RenovateTokenAlert from '../../../RenovateToken';
import Backend from '../../../Backend';
import Connection from '../../../Calls';

import BackArrow from '../../../Images/arrow-left.svg';
import Check from '../../../Images/check.svg';


class AddDevice extends Component{
  constructor(props){
    super(props)
    this.state = {
      step:1,
      name:'',
      user_name:'',
      tag:'',
      currency:'',
      api_keys:[{}],
      loading:true
    }
  }

  componentDidMount(){
    this.getKeys()
  }

  getKeys(){
    let body = this.state
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      let payload = response.payload
      Backend.general_get('get_general_settings', payload.r01,response=>{

        let keyObj = response.payload.general_settings.api_keys[0]
        if(response.status.code == '0') {
          this.setState({ api_key: keyObj.apiKey })
          Backend.GetAPISecret(localStorage.getItem('email'), localStorage.getItem('token'), keyObj.id, keyObj.apiKey, payload.r01, response => {
            if(response.status.code == 0){
              this.setState({
                api_secret:response.payload.apiSecret,
                api_totp:response.payload.apiTotp,
                loading:false
              })
            }
          });
        }
      });
    });
  }

  activateDevice(){
    this.setState({loadActive:true})
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      let payload = response.payload
      Backend.activate_device(payload.r01, this.state, response => {
        if(response.status.code == 0) this.setState({loadActive:false, step:4})
        else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          this.refs.digit_ref1.focus();
          this.setState({
            loadActive: false,
            digit1: '',
            digit2: '',
            digit3: '',
            digit4: '',
            digit5: '',
            digit6: '',
          })
        }
      });
    });
  }

  disableButton(){
    let { name, user_name, currency } = this.state
    if(name === '' || user_name === '' || currency === '' ) return true
    else return false
  }

  step1(){
    let { ecomm } = this.props.traductions
    return(
      <>
        <p>Confirguración</p>

        <Form.Label className="ecommerce_input_label">{ecomm.deviceName}:</Form.Label>
        <FormControl
          type="text"
          className="ecommerce_input"
          style={{marginBottom:10}}
          value={this.state.name}
          onChange={(name) => { this.setState({ name: name.target.value }) }}
          />

        <Form.Label className="ecommerce_input_label">{ecomm.deviceUserName}:</Form.Label>
        <FormControl
          type="text"
          className="ecommerce_input"
          style={{marginBottom:10}}
          value={this.state.user_name}
          onChange={(user_name) => { this.setState({ user_name: user_name.target.value }) }}
          />

        <Form.Label className="ecommerce_input_label">{ecomm.deviceCoin}:</Form.Label>
        <Dropdown style={{marginBottom:10}}>
          <Dropdown.Toggle style={{width:'100%'}} className='ecommerce_input form-control'id="dropdown-custom-1">
            {
              (this.state.currency)
              ?this.state.currency.toUpperCase()
              :ecomm.select
            }
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item as="button" onClick={()=>this.setState({currency:'mxn'})}>
              MXN
            </Dropdown.Item>
            <Dropdown.Item as="button" onClick={()=>this.setState({currency:'usd'})}>
              USD
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Button className='ecommerce_signup_button medium-dms' disabled={this.disableButton()} onClick={()=>this.setState({step:2})}>
          {ecomm.continue}
        </Button>
      </>
    )
  }

  step2(){
    let { api_key, api_secret, api_totp, name, user_name, currency, loading } = this.state
    let { ecomm } = this.props.traductions
    if(loading){
      return <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'300px'}}><Spinner animated color='#053164' size={60}/></div>
    }else{
      let qrString = 'wbd:' + api_key  + ':' +  api_secret  + ':' +  api_totp  + ':' +  name + ':' +  user_name + ':' +  currency
      return(
        <div style={{textAlign:'center'}}>
          <p>{ecomm.scan}</p>
          <QRCode
            bgColor="#FFFFFF"
            fgColor="#0F4C81"
            ecLevel="M"
            size={300}
            value={qrString}
            logoWidth={70}
            logoOpacity={0.6}
            qrStyle={"dots"}
          />
          <Button className='ecommerce_signup_button medium-dms' onClick={()=>this.setState({step:3})}>
            {ecomm.continue}
          </Button>
        </div>
      )
    }
  }


  _handleChange(num,e) {
    const self = this;
    var target = e.target;
    var currentState = this.state
    currentState.err2FA = '';
    var myLength = target.value.length;
    if (myLength == 1) {
      currentState['digit' + num] = e.target.value
      this.setState(currentState,()=>{
        if(num != 6)self.refs['digit_ref' + (num+1)].focus();
        else self.activateDevice()
      })
    } else if (myLength == 0){
      currentState['digit' + num] = e.target.value
      this.setState(currentState)
      if(num != 1)self.refs['digit_ref' + (num-1)].focus();
    }if (myLength > 1){
      currentState['digit' + (num+1)] = e.target.value[1]
      this.setState(currentState)
      if(num != 6)self.refs['digit_ref' + (num+1)].focus();
    }
  }

  handleKeyDown(e,n){
    const self = this;
    var target = e.target;
    var myLength = target.value.length;
    if(myLength < 1){
      if (e.keyCode === 8) {
        self.refs['digit_ref' + n].focus();
      }
    }
  }

  step3(){
    let { ecomm } = this.props.traductions
    return(
      <div style={{textAlign:'center', padding:30}}>
        <p>{ecomm.typeCode}</p>
          <Row>
            <Col xs={2}>
              <input
                className="form-control digits-google-autenticathor"
                type="number"
                name='digit_ref1'
                ref='digit_ref1'
                maxlength='1'
                value={this.state.digit1}
                onChange={(digit1) => {this._handleChange(1,digit1)}}
              />
            </Col>
            <Col xs={2}>
              <input
                className="form-control digits-google-autenticathor"
                type="number"
                name='digit_ref2'
                ref='digit_ref2'
                maxlength='1'
                value={this.state.digit2}
                onChange={(digit2)=> {this._handleChange(2,digit2)}}
                onKeyDown={(digit2) => {this.handleKeyDown(digit2,1)}}
              />
            </Col>
            <Col xs={2}>
              <input
                className="form-control digits-google-autenticathor"
                type="number"
                name='digit_ref3'
                ref='digit_ref3'
                maxlength='1'
                value={this.state.digit3}
                onChange={(digit3) => {this._handleChange(3,digit3)}}
                onKeyDown={(digit3) => {this.handleKeyDown(digit3,2)}}
              />
            </Col>
            <Col xs={2}>
              <input
                className="form-control digits-google-autenticathor"
                type="number"
                name='digit_ref4'
                ref='digit_ref4'
                maxlength='1'
                value={this.state.digit4}
                onChange={(digit4) => {this._handleChange(4,digit4)}}
                onKeyDown={(digit4) => {this.handleKeyDown(digit4,3)}}
              />
            </Col>
            <Col xs={2}>
              <input
                className="form-control digits-google-autenticathor"
                type="number"
                name='digit_ref5'
                ref='digit_ref5'
                maxlength='1'
                value={this.state.digit5}
                onChange={(digit5) => { this._handleChange(5,digit5)}}
                onKeyDown={(digit5) => {this.handleKeyDown(digit5,4)}}
              />
            </Col>
            <Col xs={2}>
              <input
                className="form-control digits-google-autenticathor"
                type="number"
                name='digit_ref6'
                ref='digit_ref6'
                maxlength='1'
                value={this.state.digit6}
                onChange={(digit6) => { this._handleChange(6,digit6)}}
                onKeyDown={(digit6) => {this.handleKeyDown(digit6,5)}}
              />
            </Col>
          </Row>
      </div>
    )
  }

  step4(){
    let { ecomm } = this.props.traductions
    return(
      <div style={{textAlign:'center', padding:30}}>
        <div style={{borderRadius:1000, height:30, width:30}}/>
        <div style={{textAlign:'center',marginBottom:15}}>
          <Image src={Check} style={{height:40, width:40}}/>
        </div>
        <p className='dark-text medium-dms font-22'>{ecomm.deviceSuccess}</p>
        <p className='dark-text medium-dms font-22'>{ecomm.theDevice} {this.state.name} {ecomm.deviceReady}</p>
        <Button className='ecommerce_signup_button medium-dms' onClick={()=>this.props.data.history.push('/ecommerce/devices')}>
          {ecomm.finish}
        </Button>
      </div>
    )
  }

  renderContent(){
    switch(this.state.step){
      case 1:
        return this.step1()
      case 2:
        return this.step2()
      case 3:
        return this.step3()
      case 4:
        return this.step4()
    }
  }

  handleBack(){
    if(this.state.step !== 1){
      this.setState({step: this.state.step - 1 })
    }else this.props.data.history.push('/ecommerce/devices')
  }

  render(){
    let { ecomm } = this.props.traductions
    return(
      <div>
        <NavbarComponent data={this.props} selected="ecommerce" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>
          <Container className='ecommerce_signup'>
            <div>
              <div className='back-button' style={{width:110, cursor:'pointer', marginTop:-15, marginBottom:10}} onClick={()=>this.handleBack()}>
                <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/>
                {ecomm.goBack}
              </div>
            </div>
            <p className='dark-text medium-dms text-25'>{ecomm.b_addDevice}</p>

            <div className='container-transactions'>
              {this.renderContent()}
            </div>
          </Container>
        </div>

      </div>
    )
  }
}
export default AddDevice;
